<template>
  <div class="container">
    <vue-alert ref="alert" :text="main_data.typ_data_coerce.title"></vue-alert>
    <vue-dialog
      :color="data_color"
      v-if="show_dialog"
      :name="data_name"
      :left="data_left"
      :right="data_right"
      :title="data_title"
      :value="data_value"
      @dialog_end="dialogend"
    >
    </vue-dialog>
    <div class="top">
      <div class="back-arrow" @click="$emit('back-step', 2)">
        <img src="../../assets/images/desktop/back_passive.svg" alt="" />
      </div>
      {{ uppercase(main_data.typ_select_house.title) }}
    </div>
    <div class="middle">
      <div class="row">
        <div class="left">
          <div class="select-row">
            <div class="inner-left grow">
              {{ main_data.typ_constdate.title }}
            </div>
            <div class="inner-right width-200">
              <!-- Odabir perioda gradnje -->
              <vue-select
                :design="{ color: '#2DB46A', width: '100%', wide: true, color_disabled: '#1d4e60' }"
                :data="{
                  data: main_data.typ_constdate.data,
                  value: main_data.typ_constdate.value,
                  text: main_data.typ_constdate.data_select,
                  isInteger: false,
                }"
                @vue-select-change="valuechange('typ_constdate', $event)"
              ></vue-select>
            </div>
          </div>
          <div class="select-row">
            <div class="inner-left">
              <img src="../../assets/images/01_floors.svg" alt="Floor number" />
            </div>
            <div class="inner-middle">
              {{ main_data.typ_floornumber.title }}
            </div>
            <div class="inner-right">
              <!-- Broj grejanih nivoa - etaza -->
              <vue-select
                :design="{ color: '#2DB46A', width: '100%', wide: true, color_disabled: '#1d4e60' }"
                :data="{
                  data: main_data.typ_floornumber.data_select,
                  value: main_data.typ_floornumber.value,
                  text: main_data.typ_floornumber.data_select,
                  isInteger: true,
                }"
                @vue-select-change="valuechange('typ_floornumber', $event, true)"
              ></vue-select>
            </div>
          </div>
          <div class="select-row">
            <div class="inner-left">
              <img src="../../assets/images/02_heated_area.svg" alt="Heated area" />
            </div>
            <div class="inner-middle">
              {{ main_data.typ_floorarea.title }}
            </div>
            <div class="inner-right">
              <vue-input
                :name="'typ_floorarea'"
                :key="'typ_floorarea' + refresh_key"
                :min_value="0"
                :max_value="999"
                :wide="true"
                :disabled="false"
                :value="main_data.typ_floorarea.value"
                :pre_approve="pre_approve"
                @vue-input-change="valuechange($event.name, $event.value, true, $event.approved)"
                @vue-input-coarce="vue_input_coarce"
              ></vue-input>
            </div>
          </div>
        </div>
        <div class="right">
          <div class="select-row">
            <div class="inner-left grow">
              {{ main_data.app_additional_options.title }}
            </div>
            <div class="inner-right check-box">
              <vue-checkbox
                :value="main_data.typ_additional_data.value"
                @input="set_additional"
                :class="{ 'vue-checkbox': true, green: main_data.typ_additional_data.value }"
              >
              </vue-checkbox>
            </div>
          </div>

          <div :class="{ 'select-row': true, disabled: !main_data.typ_additional_data.value }">
            <div class="inner-left">
              <svg xmlns="http://www.w3.org/2000/svg" width="47.9" height="46" viewBox="0 0 47.9 46">
                <g id="XMLID_109_" transform="translate(381 -274.7)" fill="currentColor">
                  <path
                    id="Path_184"
                    d="M-346.7 314.8H-379a2.006 2.006 0 0 1-2-2v-29.2a2.006 2.006 0 0 1 2-2h32.4a2.006 2.006 0 0 1 2 2 2.006 2.006 0 0 1-2 2H-377v25.2h30.4a2.006 2.006 0 0 1 2 2 2.094 2.094 0 0 1-2.1 2z"
                    class="cls-1"
                    data-name="Path 184"
                  />
                  <path
                    id="Path_185"
                    d="M-379 320.7a2.006 2.006 0 0 1-2-2v-42a2.006 2.006 0 0 1 2-2 2.006 2.006 0 0 1 2 2v42a2.006 2.006 0 0 1-2 2z"
                    class="cls-1"
                    data-name="Path 185"
                  />
                  <path
                    id="Path_186"
                    d="M-355.5 313.3h-13.1a.472.472 0 0 1-.5-.5v-21.6a.472.472 0 0 1 .5-.5h13.1a.472.472 0 0 1 .5.5v21.6a.536.536 0 0 1-.5.5zm-12.7-1h12.1v-20.6h-12.1z"
                    class="cls-1"
                    data-name="Path 186"
                  />
                  <path
                    id="Rectangle_94"
                    d="M0 0h9.9v1H0z"
                    class="cls-1"
                    data-name="Rectangle 94"
                    transform="translate(-343 281.2)"
                  />
                  <path
                    id="Rectangle_95"
                    d="M0 0h9.9v1H0z"
                    class="cls-1"
                    data-name="Rectangle 95"
                    transform="translate(-343 310.4)"
                  />
                  <g id="XMLID_111_">
                    <path
                      id="Rectangle_96"
                      d="M0 0h1v25H0z"
                      class="cls-1"
                      data-name="Rectangle 96"
                      transform="translate(-337.1 283.8)"
                    />
                    <path
                      id="Path_187"
                      d="M-336.6 310l-3.3-3.4.7-.8 2.6 2.7 2.7-2.7.7.8z"
                      class="cls-1"
                      data-name="Path 187"
                    />
                    <path
                      id="Path_188"
                      d="M-339.2 286.8l-.7-.7 3.3-3.4 3.4 3.4-.7.7-2.7-2.7z"
                      class="cls-1"
                      data-name="Path 188"
                    />
                  </g>
                  <path
                    id="Path_189"
                    d="M-357.5 313.3h-9.1a.472.472 0 0 1-.5-.5v-19.7a.472.472 0 0 1 .5-.5h9.1a.472.472 0 0 1 .5.5v19.7a.536.536 0 0 1-.5.5zm-8.7-1h8.1v-18.7h-8.1z"
                    class="cls-1"
                    data-name="Path 189"
                  />
                </g>
              </svg>
            </div>
            <div class="inner-middle">
              {{ main_data.app_height.title }}
            </div>
            <div class="inner-right">
              <!-- Odabir spratne visine -->
              <vue-select
                :design="{ color: '#2DB46A', color_disabled: '#1d4e60', width: '100%', wide: true }"
                :disabled="!main_data.typ_additional_data.value"
                unit="m"
                :data="{
                  data: main_data.app_height.data_value_list,
                  value: main_data.app_height.value,
                  text: main_data.app_height.data_select,
                  isInteger: false,
                }"
                @vue-select-change="valuechange('app_height', $event, true)"
              ></vue-select>
            </div>
          </div>
          <div
            v-if="typ_house_data.attic === 1"
            :class="{ 'select-row': true, disabled: !main_data.typ_additional_data.value }"
          >
            <div class="inner-left">
              <svg
                version="1.1"
                id="Layer_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 0 57.5 43.8"
                style="enable-background: new 0 0 57.5 43.8;"
                xml:space="preserve"
                width="55"
              >
                <g id="XMLID_1_" fill="currentColor">
                  <g id="XMLID_312_">
                    <rect id="XMLID_39_" x="28.2" y="10.7" class="st0" width="1" height="16.3" />
                    <polygon
                      id="XMLID_38_"
                      class="st0"
                      points="28.7,28 25.4,24.6 26.1,23.9 28.7,26.6 31.4,23.9 32.1,24.6 		"
                    />
                    <polygon
                      id="XMLID_37_"
                      class="st0"
                      points="26.1,14.1 25.4,13.4 28.7,10 32.1,13.4 31.4,14.1 28.7,11.4 		"
                    />
                  </g>
                  <g id="XMLID_304_">
                    <path
                      id="XMLID_36_"
                      class="st0"
                      d="M49.5,40.1c-1.1,0-2-0.9-2-2V21.8L28.7,8.4L9.6,21.8v16.3c0,1.1-0.9,2-2,2s-2-0.9-2-2V20.8c0-0.6,0.3-1.3,0.8-1.6L27.6,4.3c0.7-0.5,1.6-0.5,2.3,0l20.8,14.9c0.5,0.4,0.8,1,0.8,1.6v17.3C51.5,39.2,50.6,40.1,49.5,40.1z"
                    />
                    <path
                      id="XMLID_35_"
                      class="st0"
                      d="M49.5,32.2H7.6c-1.1,0-2-0.9-2-2s0.9-2,2-2h41.9c1.1,0,2,0.9,2,2S50.6,32.2,49.5,32.2z"
                    />
                    <path
                      id="XMLID_34_"
                      class="st0"
                      d="M2,26.6c-0.6,0-1.2-0.3-1.6-0.8c-0.6-0.9-0.4-2.2,0.5-2.8L27.6,4.1c0.7-0.5,1.6-0.5,2.3,0L56.6,23c0.9,0.6,1.1,1.9,0.5,2.8c-0.6,0.9-1.9,1.1-2.8,0.5L28.7,8.1L3.2,26.2C2.8,26.5,2.4,26.6,2,26.6z"
                    />
                  </g>
                </g>
              </svg>
            </div>
            <div class="inner-middle">
              {{ main_data.atc_height.title }}
            </div>
            <div class="inner-right">
              <!-- Odabir visine potkrovlja -->
              <vue-select
                :design="{ color: '#2DB46A', color_disabled: '#1d4e60', width: '100%', wide: true }"
                :disabled="!main_data.typ_additional_data.value"
                unit="m"
                :data="{
                  data: main_data.atc_height.data_value_list,
                  value: main_data.atc_height.value,
                  text: main_data.atc_height.data_select,
                  isInteger: false,
                }"
                @vue-select-change="valuechange('atc_height', $event, true)"
              ></vue-select>
            </div>
          </div>
          <div :class="{ 'select-row': true, disabled: !main_data.typ_additional_data.value }">
            <div class="inner-left">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                id="_06_windows"
                width="51"
                height="36.2"
                data-name="06_windows"
                viewBox="0 0 51 36.2"
                fill="currentColor"
              >
                <g id="XMLID_2946_">
                  <path id="XMLID_8_" d="M23.7 25.1H9.4V9.8h14.4v15.3zm-13.3-1h12.4V10.8H10.4z" class="cls-1" />
                  <path id="XMLID_2948_" d="M0 0h4.4v10.8H0z" class="cls-1" transform="translate(11.8 12)" />
                  <path id="XMLID_2947_" d="M0 0h4.4v10.8H0z" class="cls-1" transform="translate(16.9 12)" />
                </g>
                <path
                  id="XMLID_5_"
                  d="M49 36.2H2a2.006 2.006 0 0 1-2-2V2a2.006 2.006 0 0 1 2-2h47a2.006 2.006 0 0 1 2 2v32.2a2.006 2.006 0 0 1-2 2zm-45-4h43V4H4z"
                  class="cls-1"
                />
                <g id="XMLID_295_">
                  <path id="XMLID_2_" d="M41.6 25.1H27.3V9.8h14.4v15.3zm-13.3-1h12.4V10.8H28.3z" class="cls-1" />
                  <path id="XMLID_299_" d="M0 0h4.4v10.8H0z" class="cls-1" transform="translate(29.8 12)" />
                  <path id="XMLID_298_" d="M0 0h4.4v10.8H0z" class="cls-1" transform="translate(34.8 12)" />
                </g>
              </svg>
            </div>
            <div class="inner-middle">
              {{ main_data.typ_override_window.title }}
            </div>
            <div class="inner-right">
              <vue-input
                :name="'typ_override_window'"
                :key="'typ_override_window' + refresh_key"
                :min_value="0"
                :disabled="!main_data.typ_additional_data.value"
                :wide="true"
                :max_value="main_data.typ_floorarea.value"
                :value="main_data.typ_override_window.value"
                @vue-input-change="valuechange($event.name, $event.value, true, $event.approved)"
                @vue-input-coarce="vue_input_coarce"
              ></vue-input>
            </div>
          </div>
          <div
            v-if="typ_house_data.attic === 1"
            :class="{ 'select-row': true, disabled: !main_data.typ_additional_data.value }"
          >
            <div class="inner-left">
              <svg xmlns="http://www.w3.org/2000/svg" width="72.678" height="33.4" viewBox="0 0 72.678 33.4">
                <g
                  id="_08_roof_windows"
                  data-name="08_roof windows"
                  transform="translate(226.214 -380)"
                  fill="currentColor"
                >
                  <path
                    id="Path_67"
                    d="M-207.6 389l-6.8 14.1h12l6.8-14.1zm4.6 13.2h-9.8l5.8-12.1h9.8z"
                    class="cls-1"
                    data-name="Path 67"
                  />
                  <path id="Path_68" d="M-206.4 391.1l-4.8 10h3.6l4.7-10z" class="cls-1" data-name="Path 68" />
                  <path id="Path_69" d="M-202.3 391.1l-4.8 10h3.6l4.8-10z" class="cls-1" data-name="Path 69" />
                  <path
                    id="Path_70"
                    d="M-193 389l-6.8 14.1h12l6.8-14.1zm4.6 13.2h-9.8l5.8-12.1h9.8z"
                    class="cls-1"
                    data-name="Path 70"
                  />
                  <path id="Path_71" d="M-191.8 391.1l-4.8 10h3.6l4.7-10z" class="cls-1" data-name="Path 71" />
                  <path id="Path_72" d="M-187.7 391.1l-4.8 10h3.6l4.8-10z" class="cls-1" data-name="Path 72" />
                  <path
                    id="Path_73"
                    d="M-153.8 410.5L-170 381v-.1l-.1-.1c-.1-.1-.1-.2-.2-.3l-.1-.1c-.1-.1-.2-.2-.3-.2h-.1c-.1-.1-.3-.1-.4-.2H-210a1.889 1.889 0 0 0-1.8 1.1l-14.2 29.5a1.857 1.857 0 0 0 .1 1.9 1.965 1.965 0 0 0 1.7.9h38.3a1.889 1.889 0 0 0 1.8-1.1l9.7-20.1 10.6 18.7a1.087 1.087 0 0 0-.1.5 2.006 2.006 0 0 0 2 2h6.4a1.936 1.936 0 0 0 1.7-1 1.85 1.85 0 0 0 0-1.9zm-33.3-1H-221l12.2-25.5h33.9zm25.2 0a1.9 1.9 0 0 0-1.3.5l-10.7-18.9 2.3-4.8 12.7 23.1h-3z"
                    class="cls-1"
                    data-name="Path 73"
                  />
                </g>
              </svg>
            </div>
            <div class="inner-middle">
              {{ main_data.typ_override_roof_window.title }}
            </div>
            <div class="inner-right">
              <vue-input
                :name="'typ_override_roof_window'"
                :key="'typ_override_roof_window' + refresh_key"
                :min_value="0"
                :disabled="!main_data.typ_additional_data.value"
                :wide="true"
                :max_value="main_data.typ_floorarea.value"
                :value="main_data.typ_override_roof_window.value"
                @vue-input-change="valuechange($event.name, $event.value, true, $event.approved)"
                @vue-input-coarce="vue_input_coarce"
              ></vue-input>
            </div>
          </div>
          <div
            v-if="typ_house_data.attic === 0"
            :class="{ 'select-row': true, disabled: !main_data.typ_additional_data.value }"
          >
            <div class="inner-left">
              <svg
                version="1.1"
                id="Layer_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                width="51"
                fill="currentColor"
                viewBox="0 0 57.5 43.8"
                style="enable-background: new 0 0 57.5 43.8;"
                xml:space="preserve"
              >
                <g>
                  <path
                    id="XMLID_36_"
                    class="st0"
                    d="M49.5,40.1c-1.1,0-2-0.9-2-2V21.8L28.7,8.4L9.6,21.8v16.3c0,1.1-0.9,2-2,2s-2-0.9-2-2V20.8c0-0.6,0.3-1.3,0.8-1.6L27.6,4.3c0.7-0.5,1.6-0.5,2.3,0l20.8,14.9c0.5,0.4,0.8,1,0.8,1.6v17.3C51.5,39.2,50.6,40.1,49.5,40.1z"
                  />
                  <path
                    id="XMLID_34_"
                    class="st0"
                    d="M2,26.6c-0.6,0-1.2-0.3-1.6-0.8C-0.2,24.9,0,23.6,0.9,23L27.6,4.1c0.7-0.5,1.6-0.5,2.3,0L56.6,23c0.9,0.6,1.1,1.9,0.5,2.8s-1.9,1.1-2.8,0.5L28.7,8.1L3.2,26.2C2.8,26.5,2.4,26.6,2,26.6z"
                  />
                  <g>
                    <g>
                      <circle class="st1" cx="28.8" cy="22.9" r="9.8" fill="none" />
                      <path
                        class="st0"
                        d="M28.8,33.2c-5.7,0-10.3-4.6-10.3-10.3c0-5.7,4.6-10.3,10.3-10.3c5.7,0,10.3,4.6,10.3,10.3C39,28.6,34.4,33.2,28.8,33.2z M28.8,13.7c-5.1,0-9.3,4.2-9.3,9.3c0,5.1,4.2,9.3,9.3,9.3c5.1,0,9.3-4.2,9.3-9.3C38,17.8,33.9,13.7,28.8,13.7z"
                      />
                    </g>
                    <path
                      class="st0"
                      d="M36.3,21.4c-0.2-0.5-0.9-1.1-1.8-0.8L33.6,21L31.5,21l-3.4-1.7l-2.8,1.7c-0.2,0.1-1.6,0.7-3.2,0.4l-0.5-0.1l0,0.5c0,0.1-0.1,1.4,0.4,2.7l0,0l0.7,3.2l4.5-1l-0.1-0.6c1.9,0.1,3.6-0.1,4.9-0.4c0.7-0.2,1.4-0.3,1.9-0.5c1.7-0.6,2.6-1.3,2.7-1.3l0.2-0.2l-0.3-1.4l0-0.2L36.3,21.4L36.3,21.4z M22.6,22.4c1.8,0.1,3.1-0.5,3.2-0.5l0,0l2.4-1.5l0.9,0.5l-0.6,0.8l0.7,0.5l0.7-0.9l0.6,0.3l-0.5,0.7l0.7,0.5l0.6-0.8l0.1,0.1l2.4-0.1l1-0.3c0.3-0.1,0.4,0,0.5,0.1c0.1,0.1,0.2,0.2,0.2,0.2l0,0.2c-2.5,1.1-4.4,1.6-5.6,1.7c-1.4,0.2-2.1,0.1-2.1,0.1l0,0c-1.4-0.2-2.6-0.1-3.6,0.1c-0.2,0-0.3,0.1-0.5,0.1c-0.3,0.1-0.6,0.2-0.8,0.3C22.6,23.6,22.6,22.8,22.6,22.4z M33.6,24.5c-1.5,0.5-3.9,1.1-7,0.8l-0.6-0.1l0.2,0.9l-2.8,0.6l-0.3-1.6c0.2-0.2,1.5-0.9,4.5-0.5c0.2,0,1.4,0.2,3.6-0.3c1.2-0.3,2.7-0.7,4.5-1.5l0.1,0.7C35.5,23.7,34.7,24.1,33.6,24.5z"
                    />
                    <path
                      class="st0"
                      d="M23.7,22.4c-0.4,0-0.9-0.1-1.3-0.2l-0.2-0.1l-2-4.3l0.1-0.1c0-0.1,0.8-1.6,2.8-3c1.9-1.4,2.7-1.4,2.9-1.4l0.4,0l2,6.9L25.4,22C25.3,22.1,24.6,22.4,23.7,22.4z M22.9,21.4c0.9,0.3,2.2,0,2.4-0.2l2.1-1.5l-1.8-5.5c-0.3,0.1-1.1,0.5-2.1,1.2c-1.4,1-2.2,1.9-2.4,2.3L22.9,21.4z"
                    />
                  </g>
                  <path class="st0" d="M21,28.3h15.8c0,0-2.5,4.4-8.1,4.4S21,28.3,21,28.3z" />
                  <g>
                    <path
                      class="st0"
                      d="M18.6,28.2h-11c-1.1,0-2,0.9-2,2c0,1.1,0.9,2,2,2H22C20.6,31.2,19.4,29.8,18.6,28.2z"
                    />
                    <path
                      class="st0"
                      d="M49.5,28.2H38.9c-0.8,1.6-2,3-3.4,4h14c1.1,0,2-0.9,2-2C51.5,29.1,50.6,28.2,49.5,28.2z"
                    />
                  </g>
                </g>
              </svg>
            </div>
            <div class="inner-middle">{{ main_data.typ_ceiling.title }}</div>
            <div class="inner-right width-200">
              <!-- Odabir tipa potkrovlja -->
              <vue-select
                :disabled="!main_data.typ_additional_data.value"
                :design="{ color: '#2DB46A', color_disabled: '#1d4e60', width: '100%', left: true, wide: true }"
                :data="{
                  data: main_data.typ_ceiling.data,
                  value: main_data.typ_ceiling.value,
                  text: main_data.typ_ceiling.select,
                  isInteger: false,
                }"
                @vue-select-change="valuechange('typ_ceiling', $event, true)"
              ></vue-select>
            </div>
          </div>
          <div
            v-if="typ_house_data.basement === 1"
            :class="{ 'select-row': true, disabled: !main_data.typ_additional_data.value }"
          >
            <div class="inner-left">
              <svg
                version="1.1"
                id="Layer_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 0 57.5 50.6"
                style="enable-background: new 0 0 57.5 50.6;"
                xml:space="preserve"
                fill="currentColor"
                width="51"
              >
                <g id="XMLID_323_">
                  <g id="XMLID_303_">
                    <rect id="XMLID_33_" x="33.4" y="11.7" class="st0" width="1" height="16.3" />
                    <polygon
                      id="XMLID_32_"
                      class="st0"
                      points="33.9,29 30.5,25.6 31.3,24.9 33.9,27.6 36.6,24.9 37.3,25.6"
                    />
                    <polygon
                      id="XMLID_31_"
                      class="st0"
                      points="31.3,15.1 30.5,14.4 33.9,11 37.3,14.4 36.6,15.1 33.9,12.4"
                    />
                  </g>
                  <path
                    id="XMLID_30_"
                    class="st0"
                    d="M24.7,38.9c-1.1,0-2-0.9-2-2V3.1c0-1.1,0.9-2,2-2s2,0.9,2,2v33.8C26.7,38,25.8,38.9,24.7,38.9z"
                  />
                  <path
                    id="XMLID_29_"
                    class="st0"
                    d="M29.6,40.9h-9.7c-1.1,0-2-0.9-2-2s0.9-2,2-2h9.7c1.1,0,2,0.9,2,2S30.7,40.9,29.6,40.9z"
                  />
                  <path
                    id="XMLID_28_"
                    class="st0"
                    d="M53.5,34.6H24.7c-1.1,0-2-0.9-2-2s0.9-2,2-2h28.8c1.1,0,2,0.9,2,2S54.6,34.6,53.5,34.6z"
                  />
                  <path
                    id="XMLID_27_"
                    class="st0"
                    d="M24.7,10.1H5.2c-0.6,0-1-0.4-1-1s0.4-1,1-1h19.5c0.6,0,1,0.4,1,1S25.2,10.1,24.7,10.1z"
                  />
                  <rect id="XMLID_26_" x="27.8" y="8.6" class="st0" width="12.1" height="1" />
                  <g id="XMLID_442_">
                    <defs>
                      <polygon id="XMLID_441_" points="20.9,34.8 15.9,34.8 15.9,41.1 4.3,41.1 4.3,11.4 20.9,11.4" />
                    </defs>
                    <clipPath id="XMLID_510_">
                      <use xlink:href="#XMLID_441_" style="overflow: visible;" />
                    </clipPath>
                    <g id="XMLID_330_" class="st1" style="clip-path: url(#XMLID_510_);">
                      <rect
                        id="XMLID_25_"
                        x="-1.3"
                        y="-5.4"
                        transform="matrix(0.7071 0.7071 -0.7071 0.7071 9.7872 4.7143)"
                        class="st0"
                        width="1"
                        height="39.1"
                      />

                      <rect
                        id="XMLID_24_"
                        x="0.4"
                        y="-3.7"
                        transform="matrix(0.7071 0.7071 -0.7071 0.7071 11.4958 4.0064)"
                        class="st0"
                        width="1"
                        height="39.1"
                      />

                      <rect
                        id="XMLID_23_"
                        x="2.1"
                        y="-2"
                        transform="matrix(0.7071 0.7071 -0.7071 0.7071 13.2047 3.2987)"
                        class="st0"
                        width="1"
                        height="39.1"
                      />

                      <rect
                        id="XMLID_22_"
                        x="3.8"
                        y="-0.2"
                        transform="matrix(0.7071 0.7071 -0.7071 0.7071 14.9137 2.5908)"
                        class="st0"
                        width="1"
                        height="39.1"
                      />

                      <rect
                        id="XMLID_16_"
                        x="5.5"
                        y="1.5"
                        transform="matrix(0.7071 0.7071 -0.7071 0.7071 16.6223 1.883)"
                        class="st0"
                        width="1"
                        height="39.1"
                      />

                      <rect
                        id="XMLID_15_"
                        x="7.2"
                        y="3.2"
                        transform="matrix(0.7071 0.7071 -0.7071 0.7071 18.3312 1.1753)"
                        class="st0"
                        width="1"
                        height="39.1"
                      />

                      <rect
                        id="XMLID_14_"
                        x="9"
                        y="4.9"
                        transform="matrix(0.7071 0.7071 -0.7071 0.7071 20.0401 0.4676)"
                        class="st0"
                        width="1"
                        height="39.1"
                      />

                      <rect
                        id="XMLID_13_"
                        x="10.7"
                        y="6.6"
                        transform="matrix(0.7071 0.7071 -0.7071 0.7071 21.7491 -0.2403)"
                        class="st0"
                        width="1"
                        height="39.1"
                      />

                      <rect
                        id="XMLID_12_"
                        x="12.4"
                        y="8.3"
                        transform="matrix(0.7071 0.7071 -0.7071 0.7071 23.4576 -0.9482)"
                        class="st0"
                        width="1"
                        height="39.1"
                      />

                      <rect
                        id="XMLID_11_"
                        x="14.1"
                        y="10"
                        transform="matrix(0.7071 0.7071 -0.7071 0.7071 25.1666 -1.6561)"
                        class="st0"
                        width="1"
                        height="39.1"
                      />

                      <rect
                        id="XMLID_10_"
                        x="15.8"
                        y="11.7"
                        transform="matrix(0.7071 0.7071 -0.7071 0.7071 26.8753 -2.3641)"
                        class="st0"
                        width="1"
                        height="39.1"
                      />

                      <rect
                        id="XMLID_9_"
                        x="17.5"
                        y="13.4"
                        transform="matrix(0.7071 0.7071 -0.7071 0.7071 28.5843 -3.072)"
                        class="st0"
                        width="1"
                        height="39.1"
                      />

                      <rect
                        id="XMLID_8_"
                        x="19.2"
                        y="15.1"
                        transform="matrix(0.7071 0.7071 -0.7071 0.7071 30.2932 -3.7797)"
                        class="st0"
                        width="1"
                        height="39.1"
                      />

                      <rect
                        id="XMLID_7_"
                        x="20.9"
                        y="16.8"
                        transform="matrix(0.7071 0.7071 -0.7071 0.7071 32.002 -4.4872)"
                        class="st0"
                        width="1"
                        height="39.1"
                      />
                    </g>
                  </g>
                </g>
              </svg>
            </div>
            <div class="inner-middle">
              {{ main_data.typ_dubina.title }}
            </div>
            <div class="inner-right">
              <!-- Odabir dubine ukopavanja -->
              <vue-select
                :design="{ color: '#2DB46A', color_disabled: '#1d4e60', width: '100%', wide: true }"
                :disabled="!main_data.typ_additional_data.value"
                unit="m"
                :data="{
                  data: main_data.typ_dubina.data_value_list,
                  value: main_data.typ_dubina.value,
                  text: main_data.typ_dubina.data_select,
                  isInteger: false,
                }"
                @vue-select-change="valuechange('typ_dubina', $event, true)"
              ></vue-select>
            </div>
          </div>
          <div
            v-if="typ_house_data.basement === 1"
            :class="{ 'select-row': true, disabled: !main_data.typ_additional_data.value }"
          >
            <div class="inner-left">{{ main_data.typ_vrstatla.title }}</div>
            <div class="inner-right width-300">
              <!-- Odabir vrste tla -->
              <vue-select
                :design="{ color: '#2DB46A', color_disabled: '#1d4e60', width: '100%', wide: true, left: true }"
                :disabled="!main_data.typ_additional_data.value"
                :data="{
                  data: main_data.typ_vrstatla.data,
                  value: main_data.typ_vrstatla.value,
                  text: main_data.typ_vrstatla.select,
                  isInteger: false,
                }"
                @vue-select-change="valuechange('typ_vrstatla', $event, true)"
              ></vue-select>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom">
      <div class="button" @click="$emit('confirm-step', 2)">
        {{ main_data.app_confirm.title }}
      </div>
      <div v-if="initial_setup" class="text" @click="$emit('back-step', 2)">
        {{ main_data.app_back.title }}
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;

  .top {
    margin-top: 1.2rem;
    font-family: F-Dem;
    font-size: 3.4rem;
    line-height: 1.32;
    letter-spacing: normal;
    text-align: center;
    color: $text_white;
    flex-grow: 0;
    position: relative;
    width: 100%;
    height: 4.6rem;

    .back-arrow {
      position: absolute;
      left: 3rem;
      width: 6.4rem;
      height: 6.4rem;
      border-radius: 50%;
      top: -0.9rem;
      display: flex;
      justify-content: center;
      align-items: center;

      &:hover {
        background-color: $main_header_middle;
      }

      img {
        width: 3rem;
        max-width: 3rem;
      }
    }
  }

  .middle {
    margin-left: 63.8rem;
    font-size: 2.1rem;
    line-height: 1.19;

    .row {
      display: flex;
      margin: auto;
      align-items: center;
      justify-content: space-between;
      width: 106rem;
      max-width: 55vw;

      .left {
        flex: 0 0 47rem;
      }

      .right {
        flex: 0 0 44rem;
      }

      .select-row {
        align-items: center;
        justify-content: space-between;
        display: flex;
        height: 4.8rem;

        &:not(:last-child) {
          margin-bottom: 2.5rem;
        }

        &.disabled {
          .inner-left {
            color: $main_header_middle;
          }

          .inner-middle {
            color: $main_header_middle;
          }
        }

        .inner-left {
          flex: 0 0 8rem;
          display: flex;
          align-items: center;
          justify-content: flex-start;
          color: $desktop_green;

          &.grow {
            flex-grow: 1;
          }

          svg {
            max-width: 5rem;
          }

          img {
            max-width: 5.5rem;
          }
        }

        .inner-middle {
          flex: 1 1 auto;
          display: flex;
          align-items: center;
          justify-content: flex-start;
          color: $text_white;
        }

        .inner-right {
          flex: 0 0 12rem;
          height: 100%;
          display: flex;
          align-items: center;

          &.width-200 {
            flex: 0 0 20rem;
          }

          &.width-300 {
            flex: 0 0 28rem;
          }

          .vue-checkbox {
            height: 3rem;
            width: 3rem;
            border: 2px solid $desktop_green;
            background-color: $main_header_middle;
            margin-left: auto;
            margin-right: 1rem;

            &.green {
              background-color: $desktop_green;
              border: none;
            }
          }
        }
      }
    }
  }

  .bottom {
    .button {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0 auto 1.1rem auto;
      background-color: $desktop_green;
      height: 7rem;
      width: 26.4rem;
      border-radius: 3.5rem;
      font-size: 2.5rem;
      line-height: 1.16;
      color: $text_white;
      flex-grow: 0;
      cursor: pointer;
    }

    .text {
      font-size: 2.1rem;
      line-height: 1.19;
      text-align: center;
      color: $desktop_text_inactive;
      cursor: pointer;
    }
  }
}
</style>

<script>
import mixin from "../../lib/mixins.js";
import dialog from "../../components/dialog";
import superconsole from "../../lib/superconsole.js";
import select from "../../components/select.vue";
import input from "../../components/input.vue";
import alert from "../../components/alert.vue";
import checkbox from "../../components/checkbox.vue";

export default {
  mixins: [mixin],
  props: ["main_data", "get_intervention_exists", "get_intervention_20_21_exists", "typ_house_data", "initial_setup"],
  components: {
    "vue-dialog": dialog,
    "vue-select": select,
    "vue-input": input,
    "vue-alert": alert,
    "vue-checkbox": checkbox,
  },
  data: function () {
    return {
      choosed: -1,
      hovered: 1,
      show_dialog: false,
      data_title: "",
      data_name: "",
      data_left: "",
      data_right: "",
      data_color: "",
      data_value: {},
      promise: null,
      refresh_key: 0,
    };
  },
  methods: {
    pre_approve: async function (name, value) {
      return new Promise((res) => {
        this.promise = res;
        this.dialogstart(name, value);
      });
    },
    dialogstart: async function (name, value) {
      const showDialog = (title, intervention, color = "#24c46c") => {
        this.data_title = title;
        this.data_left = this.main_data.app_proceed.title;
        this.data_right = this.main_data.app_cancel.title;
        this.data_value = { name: name, value: value };
        this.data_name = intervention;
        this.show_dialog = true;
        this.data_color = color;
      };

      if (
        (name === "typ_floorarea" || name === "typ_floornumber") &&
        (this.main_data.typ_override_window_manual.value ||
          this.main_data.typ_override_roof_window_manual.value ||
          this.get_intervention_20_21_exists)
      ) {
        if (
          (this.main_data.typ_override_window_manual.value || this.main_data.typ_override_roof_window_manual.value) &&
          this.get_intervention_20_21_exists
        ) {
          showDialog(this.main_data.app_intervention_20_21_all_reset.title, "20_21");
        } else if (
          this.main_data.typ_override_window_manual.value ||
          this.main_data.typ_override_roof_window_manual.value
        ) {
          showDialog(this.main_data.typ_window_delete.title);
        } else {
          showDialog(this.main_data.app_intervention_20_21_reset.title, "20_21");
        }
      } else if (name === "typ_constdate" && this.get_intervention_exists) {
        showDialog(this.main_data.app_intervention_reset.title, "all");
      } else if ((name === "typ_vrstatla" || name === "typ_dubina") && this.get_intervention_20_21_exists) {
        showDialog(this.main_data.app_intervention_20_21_reset.title, "20_21");
      } else if (
        (this.main_data.typ_override_window_manual.value && (name === "atc_height" || name === "app_height")) ||
        (this.main_data.typ_override_roof_window_manual.value && name === "atc_height")
      ) {
        showDialog(this.main_data.typ_window_delete.title);
      } else {
        this.promise(true);
      }
    },
    dialogend: function (ev) {
      if (ev.confirm) {
        if ((ev.name === "all" || ev.name === "20_21") && ev.value.name !== "typ_constdate") {
          if (ev.name === "all") {
            this.$emit("reset-whole-intervention");
          } else {
            this.$emit("reset-status-data", { value: 20 });
            this.$emit("reset_status_data", { value: 21 });
          }
        }
        this.promise(true);
      } else {
        this.promise(false);
      }

      this.show_dialog = false;
    },
    valuechange: async function (name, value, isnumber, approved) {
      if (isnumber) {
        value = +value;
      }

      if (!approved) {
        if (!(await this.pre_approve(name, value))) return;
      }

      // eslint-disable-next-line
      superconsole.log("emit", name, value);

      // OVO MORA DA IDE PRE NEGO STO SE SAMA VREDNOST IZMENI
      if (name === "typ_override_window" || name === "typ_override_roof_window") {
        this.$emit("value-change", {
          name: name + "_manual",
          value: true,
        });
      }

      if (name === "typ_constdate") {
        this.$emit("value-change", {
          name: "typ_stanje",
          value: value.endsWith("_new_house") ? 2 : 1,
        });
      }

      this.$emit("value-change", {
        name: name,
        value: value,
      });

      this.refresh_key = 1 - this.refresh_key;
    },
    vue_input_coarce: function () {
      this.$refs.alert.show();
    },
    set_additional: function () {
      if (this.main_data.typ_additional_data.value) {
        this.$emit("value-change", {
          name: "app_height",
          value: this.main_data.app_height.value_default,
        });
        this.$emit("value-change", {
          name: "atc_height",
          value: this.main_data.atc_height.value_default,
        });
        this.$emit("value-change", {
          name: "typ_ceiling",
          value: this.main_data.typ_ceiling.value_default,
        });
        this.$emit("value-change", {
          name: "typ_dubina",
          value: this.main_data.typ_dubina.value_default,
        });
        this.$emit("value-change", {
          name: "typ_vrstatla",
          value: this.main_data.typ_vrstatla.value_default,
        });
      }

      this.$emit("value-change", {
        name: "typ_additional_data",
        value: !this.main_data.typ_additional_data.value,
      });
    },
  },
};
</script>
